var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCredits(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_629_6566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 0H1.83333C1.3471 0 0.880786 0.193153 0.53697 0.53697C0.193153 0.880786 0 1.3471 0 1.83333V14.6667C0 15.1529 0.193153 15.6192 0.53697 15.963C0.880786 16.3068 1.3471 16.5 1.83333 16.5H20.1667C20.6529 16.5 21.1192 16.3068 21.463 15.963C21.8068 15.6192 22 15.1529 22 14.6667V1.83333C22 1.3471 21.8068 0.880786 21.463 0.53697C21.1192 0.193153 20.6529 0 20.1667 0ZM21.0833 14.6667C21.0833 14.9098 20.9867 15.1429 20.8148 15.3148C20.6429 15.4868 20.4098 15.5833 20.1667 15.5833H1.83333C1.59022 15.5833 1.35707 15.4868 1.18517 15.3148C1.01326 15.1429 0.916667 14.9098 0.916667 14.6667V7.33333H21.0833V14.6667ZM21.0833 6.41667H0.916667V4.58333H21.0833V6.41667ZM21.0833 3.66667H0.916667V1.83333C0.916667 1.59022 1.01326 1.35706 1.18517 1.18515C1.35707 1.01324 1.59022 0.916667 1.83333 0.916667H20.1667C20.4098 0.916667 20.6429 1.01324 20.8148 1.18515C20.9867 1.35706 21.0833 1.59022 21.0833 1.83333V3.66667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0418 10.0833H18.7918C18.9134 10.0833 19.03 10.035 19.1159 9.94908C19.2019 9.86313 19.2502 9.74655 19.2502 9.625C19.2502 9.50344 19.2019 9.38687 19.1159 9.30091C19.03 9.21496 18.9134 9.16666 18.7918 9.16666H16.0418C15.9203 9.16666 15.8037 9.21496 15.7177 9.30091C15.6318 9.38687 15.5835 9.50344 15.5835 9.625C15.5835 9.74655 15.6318 9.86313 15.7177 9.94908C15.8037 10.035 15.9203 10.0833 16.0418 10.0833Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_629_6566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16.5,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredits);
export default __webpack_public_path__ + "static/media/credits.adc9519825c0837c110a023f759c21f6.svg";
export { ForwardRef as ReactComponent };